module.exports = __webpack_public_path__ + "static/media/shield-cross.f2ae2996.svg";